/**
 * MuiAlertBase
 */
export const MuiAlertBase = {};

/**
 * MuiAlert
 *
 * Demos:
 *
 * - [Alert](https://ui-packages.isbuildingluma.com/ui-core/react-alert/)
 *
 * API:
 *
 * - [Alert API](https://ui-packages.isbuildingluma.com/ui-core/api/alert/)
 * - inherits [MuiAlert API](https://mui.com/material-ui/api/alert/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/design/WJDRbOCCrGVDTsbUC3yvp8/Luma-Design-System?node-id=3108-28049&node-type=frame&t=xVtSqOYK7MKIyCvM-0)
 */
const MuiAlert = {
  defaultProps: {
    variant: 'outlined'
  },
  styleOverrides: {
    outlinedInfo: ({
      theme
    }) => ({
      borderColor: theme.palette.secondary.main,
      '& .MuiAlert-icon': {
        color: theme.palette.secondary.main
      }
    })
  }
};
export default MuiAlert;